export enum SubscribeRespostaEnum{
  OK = 201,
  VAZIO = 400,
  EMAIL_EXISTENTE = 409,
  ERRO_INDEFINIDO = 0,
}